import {
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

export interface Attachment {
  id: string | number;
  filename: string;
  fileurl?: string;
  file?: File;
  size: number;
  extension: string;
  isNew: boolean;
}

@Component({
  selector: 'app-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.scss'],
  standalone: false
})
export class AttachmentListComponent {

  @Input() files: Attachment[] = [];

  @Input() mode: 'edit' | 'view' = 'edit';

  @Input() maxSizeMB = 5;

  @Input() allowedTypes = '.pdf,.doc,.docx';

  @Output() filesSelected = new EventEmitter<FileList>();

  @Output() fileRemoved = new EventEmitter<Attachment>();

  ngOnInit() {
    console.log(this.mode);
  }
  /**
   * Calculates the total size of all attachments in megabytes (MB) and returns it as a string formatted to two decimal places.
   */
  get totalSizeMB(): string {
    const totalBytes = this.files.reduce(
      (sum, file) => sum + (file.size || 0),
      0
    );

    return (totalBytes / 1024 / 1024).toFixed(2);
  }

  /**
   * Handles the change event when files are selected.
   * @param event The change event triggered by the file input.
   */
  onFileChange(event: Event): void {
    const files = (event.target as HTMLInputElement).files;

    if (files && files.length) {
      this.filesSelected.emit(files);
    }
  }

  /**
   * Removes a file from the list and emits the fileRemoved event.
   * @param file The file to be removed.
   */
  remove(file: Attachment): void {
    this.fileRemoved.emit(file);
  }

  /**
   * Tracks a file by its unique identifier or filename to optimize rendering.
   * @param index The index of the file in the list.
   * @param file The file to be tracked.
   */
  trackByFile(index: number, file: Attachment): string {
    return file.id ? file.id.toString() : file.filename;
  }
}
